import styled from '@emotion/styled';
import * as React from '@emotion/react';
import { FeaturesHighlightContainer } from './components/features-highlight-container';
import { FeaturesHighlightProps } from './models/features-highlight-props';
import { getColorCodings } from './utils/util-functions';
import { messages } from './messages';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { defaultAnalyticsData } from './utils/constants';

function FeaturesHighlightWpl({
  layoutType,
  selectedBgColor,
  isColorBar,
  barColor,
  mediaType,
  mediaSourceLinks,
  isCategoryLabel,
  intl
}: FeaturesHighlightProps & InjectedIntlProps) {
  const colorCodings = getColorCodings(selectedBgColor);

  return (
    <AnalyticsContext data={defaultAnalyticsData}>
      <Root bgColorCode={colorCodings?.colorCode}>
        <FeaturesHighlightContainer
          layoutType={layoutType}
          colorCoding={colorCodings}
          isColorBar={isColorBar}
          barColor={barColor}
          isCategoryLabel={isCategoryLabel}
          mediaType={mediaType}
          mediaSourceLinks={mediaSourceLinks}
          intl={intl}
        />
      </Root>
    </AnalyticsContext>
  );
}

const Root = styled.div<{ bgColorCode?: string }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  background-color: ${(props) => props.bgColorCode};
`;

FeaturesHighlightWpl.messages = messages;
export default injectIntl(FeaturesHighlightWpl);
